<script context="module">
  import sprite from 'svg-sprite-loader/runtime/sprite.build'
  import { KEYS } from '../utils'

  import armchair from './_assets/armchair.icon.svg'
  import arrow from './_assets/arrow.icon.svg'
  import arrowGeo from './_assets/arrowGeo.icon.svg'
  import atomizer from './_assets/atomizer.icon.svg'
  import award from './_assets/award.icon.svg'
  import bed from './_assets/bed.icon.svg'
  import balcony from './_assets/balcony.icon.svg'
  import balconyWindow from './_assets/balconyWindow.icon.svg'
  import bar from './_assets/bar.icon.svg'
  import bidet from './_assets/bidet.icon.svg'
  import bottle from './_assets/bottle.icon.svg'
  import cart from './_assets/cart.icon.svg'
  import chandelier from './_assets/chandelier.icon.svg'
  import cover from './_assets/cover.icon.svg'
  import cupboard from './_assets/cupboard.icon.svg'
  import dishware from './_assets/dishware.icon.svg'
  import enter from './_assets/enter.icon.svg'
  import heart from './_assets/heart.icon.svg'
  import iron from './_assets/iron.icon.svg'
  import keysLeft from './_assets/keysLeft.icon.svg'
  import keysRight from './_assets/keysRight.icon.svg'
  import like from './_assets/like.icon.svg'
  import loader from './_assets/loader.icon.svg'
  import map from './_assets/map.icon.svg'
  import microwaveOven from './_assets/microwaveOven.icon.svg'
  import mirror from './_assets/mirror.icon.svg'
  import mopBucket from './_assets/mopBucket.icon.svg'
  import petTray from './_assets/petTray.icon.svg'
  import ruble from './_assets/ruble.icon.svg'
  import faceMan from './_assets/faceMan.icon.svg'
  import faceGirl from './_assets/faceGirl.icon.svg'
  import fridge from './_assets/fridge.icon.svg'
  import handset from './_assets/handset.icon.svg'
  import labelFive from './_assets/labelFive.icon.svg'
  import labelPercent from './_assets/labelPercent.icon.svg'
  import phone from './_assets/phone.icon.svg'
  import question from './_assets/question.icon.svg'
  import shield from './_assets/shield.icon.svg'
  import shirts from './_assets/shirts.icon.svg'
  import shower from './_assets/shower.icon.svg'
  import sink from './_assets/sink.icon.svg'
  import star from './_assets/star.icon.svg'
  import stoveTop from './_assets/stoveTop.icon.svg'
  import stoveFront from './_assets/stoveFront.icon.svg'
  import table from './_assets/table.icon.svg'
  import toiletBowl from './_assets/toiletBowl.icon.svg'
  import trashBucket from './_assets/trashBucket.icon.svg'
  import virus from './_assets/virus.icon.svg'
  import wardrobe from './_assets/wardrobe.icon.svg'
  import window from './_assets/window.icon.svg'
  import facebook from './_assets/facebook.icon.svg'
  import instagram from './_assets/instagram.icon.svg'
  import vk from './_assets/vk.icon.svg'
  import successCircle from './_assets/successCircle.icon.svg'
  import errorCircle from './_assets/errorCircle.icon.svg'
  import sprayBottle from './_assets/sprayBottle.icon.svg'
  import checkSquare from './_assets/checkSquare.icon.svg'
  import clock from './_assets/clock.icon.svg'
  import refund from './_assets/refund.icon.svg'
  import master from './_assets/master.icon.svg'
  import shipping from './_assets/shipping.icon.svg'
  import vacuumCleaner from './_assets/vacuumCleaner.icon.svg'
  import colorBaby from './_assets/colorBaby.icon.svg'
  import colorCurtains from './_assets/colorCurtains.icon.svg'
  import colorDress from './_assets/colorDress.icon.svg'
  import colorHatFedora from './_assets/colorHatFedora.icon.svg'
  import colorHighHeels from './_assets/colorHighHeels.icon.svg'
  import colorNeedle from './_assets/colorNeedle.icon.svg'
  import colorShirtTie from './_assets/colorShirtTie.icon.svg'
  import colorSuitTie from './_assets/colorSuitTie.icon.svg'
  import colorTShirt from './_assets/colorTShirt.icon.svg'
  import colorTowel from './_assets/colorTowel.icon.svg'
  import colorWardrobe from './_assets/colorWardrobe.icon.svg'
  import colorShoe from './_assets/colorShoe.icon.svg'
  import colorWashingMachine from './_assets/colorWashingMachine.icon.svg'
  import colorBra from './_assets/colorBra.icon.svg'
  import colorFavorite from './_assets/colorFavorite.icon.svg'
  import bubbles from './_assets/bubbles.icon.svg'
  import washingMachine from './_assets/washingMachine.icon.svg'
  import ironing from './_assets/ironing.icon.svg'
  import done from './_assets/done.icon.svg'
  import gift from './_assets/gift.icon.svg'
  import moneyThrough from './_assets/moneyThrough.icon.svg'
  import palmThrough from './_assets/palmThrough.icon.svg'
  import diamond from './_assets/diamond.icon.svg'
  import effects from './_assets/effects.icon.svg'

  const icons = {
    armchair,
    arrow,
    arrowGeo,
    atomizer,
    award,
    bed,
    balcony,
    balconyWindow,
    bar,
    bidet,
    bottle,
    cart,
    chandelier,
    cover,
    cupboard,
    dishware,
    enter,
    heart,
    iron,
    keysLeft,
    keysRight,
    like,
    loader,
    map,
    microwaveOven,
    mirror,
    mopBucket,
    petTray,
    ruble,
    faceMan,
    faceGirl,
    fridge,
    handset,
    labelFive,
    labelPercent,
    phone,
    question,
    shield,
    shirts,
    shower,
    sink,
    star,
    stoveTop,
    stoveFront,
    table,
    toiletBowl,
    trashBucket,
    virus,
    wardrobe,
    window,
    facebook,
    instagram,
    vk,
    successCircle,
    errorCircle,
    sprayBottle,
    checkSquare,
    clock,
    refund,
    master,
    shipping,
    vacuumCleaner,
    colorBaby,
    colorCurtains,
    colorDress,
    colorHatFedora,
    colorHighHeels,
    colorNeedle,
    colorShirtTie,
    colorSuitTie,
    colorTShirt,
    colorTowel,
    colorWardrobe,
    colorWashingMachine,
    colorBra,
    colorFavorite,
    bubbles,
    washingMachine,
    ironing,
    done,
    gift,
    moneyThrough,
    palmThrough,
    diamond,
    effects,
    colorShoe,
  }

  const NAMES = Object.keys(icons).reduce(
    (acc, iconName) => ({ ...acc, [`${iconName}`]: iconName }), // do not remove iconName template string, it`s fuckging bug
    {}
  )

  const spriteContent = sprite.stringify()

  export { NAMES, KEYS, spriteContent }
</script>

<script>
  import { getClass } from '../utils'

  const symbols = sprite.symbols.reduce((acc, data) => ({ ...acc, [data.id]: data }), {})

  export let name
  export let key
  export let clickable = false

  $: icon = (function getIconId(id) {
    if (icons[id] === undefined) {
      throw new Error(`Icon ${id} does not exist`)
    }

    return icons[id]
  })(name)

  $: className = getClass({ key, clickable, className: $$props.class || '' })
</script>

<span {...$$restProps} class={className}>
  <svg viewBox={icon.viewBox}>
    <use href={`#${icon.id}`} />
  </svg>
</span>
